export const formatInput = (value) => {
  return value
    .toString()
    .replace(/[^0-9-]/g, "")
    .replace(/^-/, "");
};

export function insertCommas(num = 0) {
  const numberString = num.toString();
  let result = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return result;
}
